import React from "react";

const CareersHero = () => {

    return (
        <>
            <section className="career-hero">

                <div className="career-glow glow-1"></div>
                <div className="career-glow glow-2"></div>

                <div className="career-container">

                    {/* LEFT */}

                    <div className="career-content">

                        <div className="career-badge">
                            🚀 WE ARE HIRING
                        </div>

                        <h1>
                            Build Your
                            <br />
                            Future With
                            <span> AppVerseLabs</span>
                        </h1>

                        <p>
                            Join a team of passionate developers, designers
                            and innovators building world-class digital
                            products. Work on exciting projects, learn
                            cutting-edge technologies and grow your career
                            faster than ever.
                        </p>

                        <div className="career-buttons">

                            <a href="#jobs">
                                View Open Positions
                            </a>

                            <a href="#culture" className="outline-btn">
                                Life At AppVerseLabs
                            </a>

                        </div>

                        <div className="career-stats">

                            <div>
                                <h3>25+</h3>
                                <span>Team Members</span>
                            </div>

                            <div>
                                <h3>100+</h3>
                                <span>Projects Delivered</span>
                            </div>

                            <div>
                                <h3>4.9★</h3>
                                <span>Employee Rating</span>
                            </div>

                        </div>

                    </div>

                    {/* RIGHT */}

                    <div className="career-visual">
                        <div className="career-card main-card">
                            <div className="career-icon">
                                💼
                            </div>
                            <h3>
                                Join Our Team
                            </h3>
                            <p>
                                Build products used by thousands of users.
                            </p>
                        </div>
                    </div>

                </div>

                <style>{`
                .career-hero{
                    position:relative;
                    overflow:hidden;
                    padding:140px 24px;
                    background:
                    linear-gradient(
                        180deg,
                        #ffffff 0%,
                        #fff7f7 50%,
                        #ffffff 100%
                    );
                }

                .career-container{
                    max-width:1400px;
                    margin:auto;
                    display:grid;
                    grid-template-columns:1.1fr .9fr;
                    gap:80px;
                    align-items:center;
                    position:relative;
                    z-index:2;
                }

                .career-badge{
                    display:inline-flex;
                    padding:12px 22px;
                    border-radius:999px;
                    background:rgba(232,33,42,.08);
                    color:#E8212A;
                    font-weight:700;
                    font-size:13px;
                    letter-spacing:1px;
                    margin-bottom:25px;
                }

                .career-content h1{
                    font-size:clamp(60px,7vw,60px);
                    line-height:.95;
                    color:#111;
                    margin-bottom:25px;
                    font-weight:800;
                    font-family:'Syne',sans-serif;
                }

                .career-content h1 span{
                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );
                    -webkit-background-clip:text;
                    -webkit-text-fill-color:transparent;
                }

                .career-content p{
                    font-size:18px;
                    line-height:1.9;
                    color:#666;
                    max-width:650px;
                    margin-bottom:40px;
                }

                .career-buttons{
                    display:flex;
                    gap:18px;
                    flex-wrap:wrap;
                    margin-bottom:50px;
                }

                .career-buttons a{
                    text-decoration:none;
                    padding:18px 28px;
                    border-radius:18px;
                    font-weight:700;
                    transition:.35s;
                }

                .career-buttons a:first-child{
                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );
                    color:#fff;
                    box-shadow:
                    0 20px 50px rgba(232,33,42,.25);
                }

                .outline-btn{
                    background:#fff;
                    border:1px solid #eee;
                    color:#111;
                }

                .career-buttons a:hover{
                    transform:translateY(-5px);
                }

                .career-stats{
                    display:flex;
                    gap:25px;
                    flex-wrap:wrap;
                }

                .career-stats div{
                    background:#fff;
                    border:1px solid #eee;
                    border-radius:22px;
                    padding:22px 28px;
                    box-shadow:
                    0 10px 30px rgba(0,0,0,.04);
                }

                .career-stats h3{
                    font-size:34px;
                    margin-bottom:6px;
                    font-family:'Syne',sans-serif;
                }

                .career-stats span{
                    color:#777;
                    font-size:14px;
                }

                .career-visual{
                    position:relative;
                    height:650px;
                }

                .main-card{
                    position:absolute;
                    left:50%;
                    top:50%;
                    transform:translate(-50%,-50%);
                    width:330px;
                    height:330px;
                    border-radius:40px;
                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );
                    color:#fff;
                    display:flex;
                    flex-direction:column;
                    align-items:center;
                    justify-content:center;
                    text-align:center;
                    box-shadow:
                    0 40px 100px rgba(232,33,42,.28);
                    animation:floatMain 5s ease-in-out infinite;
                }

                .career-icon{
                    width:90px;
                    height:90px;
                    border-radius:24px;
                    background:rgba(255,255,255,.15);
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    font-size:42px;
                    margin-bottom:20px;
                    backdrop-filter:blur(10px);
                }

                .main-card h3{
                    font-size:34px;
                    margin-bottom:10px;
                    font-family:'Syne',sans-serif;
                }

                .main-card p{
                    color:rgba(255,255,255,.9);
                }

                .floating-card{
                    position:absolute;
                    background:#fff;
                    padding:16px 22px;
                    border-radius:18px;
                    font-weight:700;
                    box-shadow:
                    0 20px 40px rgba(0,0,0,.08);
                    animation:floatCard 4s ease-in-out infinite;
                }

                .card-1{top:40px;left:30px;}
                .card-2{top:80px;right:20px;}
                .card-3{left:0;top:280px;}
                .card-4{right:0;top:320px;}
                .card-5{left:80px;bottom:80px;}
                .card-6{right:60px;bottom:40px;}

                .career-glow{
                    position:absolute;
                    border-radius:50%;
                    filter:blur(120px);
                    opacity:.15;
                }

                .glow-1{
                    width:450px;
                    height:450px;
                    background:#E8212A;
                    left:-150px;
                    top:-150px;
                }

                .glow-2{
                    width:350px;
                    height:350px;
                    background:#FF4D4D;
                    right:-120px;
                    bottom:-120px;
                }

                @keyframes floatMain{
                    0%,100%{
                        transform:translate(-50%,-50%) translateY(0);
                    }
                    50%{
                        transform:translate(-50%,-50%) translateY(-18px);
                    }
                }

                @keyframes floatCard{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(-10px);
                    }
                }

                @media(max-width:991px){

                    .career-container{
                        grid-template-columns:1fr;
                    }

                    .career-visual{
                        height:550px;
                    }

                }

                @media(max-width:768px){

                    .career-hero{
                        padding:100px 18px;
                    }

                    .career-content h1{
                        letter-spacing:-2px;
                    }

                    .main-card{
                        width:260px;
                        height:260px;
                    }

                    .floating-card{
                        font-size:13px;
                        padding:12px 16px;
                    }

                }

            `}</style>

            </section>
        </>
    );
};

export default CareersHero;